import { render, staticRenderFns } from "./AddOrEditBuildingModal.vue?vue&type=template&id=f346a472&scoped=true&"
import script from "./AddOrEditBuildingModal.vue?vue&type=script&lang=ts&"
export * from "./AddOrEditBuildingModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f346a472",
  null
  
)

export default component.exports